<template>
  <div>
    <Breadcrumbs title="Simulator"/>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>